<template>
  <div class="animated fadeIn">

    <b-card-body>
      <b-row>
        <b-col sm xs="12" class="text-left mt-3">
          <router-link to="/transferts/paiement-masse/model/new" v-if="can('modelpaiement-create')">
            <b-button variant="primary" class="btn-pill">
              <i class="fa fa-plus"></i>&nbsp;Nouveau
            </b-button>
          </router-link>
        </b-col>
      </b-row>
    </b-card-body>
    <b-row>
     <b-col lg="12" v-if="can('modelpaiement-list')">
        <!--<c-table-entities striped caption="<i class='fa fa-align-justify'></i> Liste des entités"></c-table-entities>-->
          <div>
              <vue-good-table styleClass="vgt-table condensed bordered striped" :columns="columns" :rows="rows" :row-style-class="rowStyleClassFn" :fixed-header="false" :pagination-options="pagination" :search-options="search" :totalRows="totalRecords" mode="remote" @on-page-change="onPageChange" @on-per-page-change="onPerPageChange" @on-sort-change="onSortChange" @on-column-filter="onColumnFilter">
                  <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field == 'btn'" style="font-size: 0.875rem;">
                        
                          <b-dropdown id="ddown-sm-split" size="sm" text="Plus de détails" class="m-2">
                            <div role="group" aria-lableledby="header1">                   
                                <router-link :to="'model/edit/' + props.row.id" v-if="can('modelpaiement-edit')"><b-dropdown-item-button aria-describedby="header1" :id="props.row.id"><i class="fa fa-edit"></i> Modifier</b-dropdown-item-button></router-link>
                                <!-- <b-dropdown-item-button aria-describedby="header1" v-if="can('user-delete')" @click.prevent="confirm()"><i class="fa fa-trash"></i> Désactiver</b-dropdown-item-button> -->
                                <!-- <router-link :to="'show/' + props.row.id" v-if="can('user-list-responsable')"><b-dropdown-item-button aria-describedby="header1"><i class="fa fa-eye"></i> Plus d'infos</b-dropdown-item-button></router-link> -->
                            </div>  
                            <div role="group" aria-lableledby="header2">
                              <b-dropdown-header id="header2">Autres actions ...</b-dropdown-header>   
                                
                                <router-link :to="'/approvisionnements/user/list/'+ props.row.id">
                                  <b-dropdown-item-button aria-describedby="header2"><i class="fa fa-money"></i> Historique des activités</b-dropdown-item-button>
                                </router-link>
                              <!--<b-dropdown-item-button aria-describedby="header2">Delete</b-dropdown-item-button>-->
                            </div>              
                          </b-dropdown>
                          
                    </span>
                    <span style="font-size: 0.875rem;" v-else>
                      {{props.formattedRow[props.column.field]}}
                    </span>
                  </template>    
              </vue-good-table>
          </div>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
//import cTableEntities from './TableEntities.vue'
import { VueGoodTable } from 'vue-good-table';
import { mapState, mapActions } from 'vuex';
export default {
  name: 'tables',
  //components: {cTableEntities},
  components: {VueGoodTable},
   data(){
    return {
      totalRecords :0,
      columns: [
        {
          label: 'Nom',
          field: 'nom',
          filterable: true,
          width: '150px',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: '', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Prénom(s)',
          field: 'prenom',
          width: '150px',
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: '', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Adresse',
          field: 'adresse',
          width: '150px',
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: '', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Téléphone',
          field: 'telephone',
          width: '150px',
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: '', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Model',
          field: 'model',
          
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: '', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Montant transféré',
          field: 'montant_transfere',
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: '', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Périodicité jour',
          field: 'periodicite_jour',
          width: '150px',
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: '', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Grille tarifiare',
          field: 'grilletarifaires_libelle',
          width: '150px',
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: '', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Crée le',
          field: 'date_operation',
          type: 'date',
          width: '150px',
          dateInputFormat: 'YYYY-MM-DD',
          dateOutputFormat: 'YYYY-MM-DD',
          formatFn: this.formatFn,
          filterable: true,
          thClass: 'custom-th-class',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: '', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Action',
          field: 'btn',
          html: true,
          width: '150px',
        }
      ],
      rows: [],
      pagination:{
          enabled: true,
          mode: 'pages',
          perPage: 10,
          position: 'bottom',
          perPageDropdown: [3,5, 10, 50,100],
          dropdownAllowAll: false,
          setCurrentPage: 1,
          nextLabel: 'Suivant',
          prevLabel: 'Précédent',
          rowsPerPageLabel: 'Lignes par page',
          ofLabel: 'de',
          pageLabel: 'page', // for 'pages' mode
          allLabel: 'All',
      },
      search:{
          enabled: false,
          trigger: 'keyup',
          placeholder: 'Rechercher dans la table',
      },
      serverParams: {
        name:'',
        email:'',
        entite_nom:'',
        agence_nom:'',
        agence_ville:'',
        role_name:'',
        date_operation:'',
        page:1,
        current_page: 1,
        nb_lines:10
      }
    };
  },
  methods:{
    formatFn: function (value) {
        return value != null ? value : null
    },
    hideModal () {
    this.$refs.myModalRef.hide()
    },
    async cancel_delete(){
        this.hideModal()
    },
    async confirm(){
        this.$refs.myModalRef.show()
    },
    rowStyleClassFn(row) {
      return row.role === 'Operateur de Distributeur' ? 'green' : 'red';
    },
    can(perm){
        return store.getters['auth/can'](perm)
    },
    async get_all_users(){
        this.$store.dispatch('user/get_all_users').then(()=>{
          return this.rows =  store.getters['user/rows'];
        })
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    onPageChange(params) {
      this.serverParams.page = params.currentPage
      this.updateParams({page: params.currentPage,current_page: params.currentPage});
      this.loadItems();
    },
    onPerPageChange(params) {
      this.serverParams.nb_lines = params.currentPerPage
      console.log(params)
      this.updateParams({page: params.currentPage,paginate:params.currentPerPage});
      this.loadItems();
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field,
        },
      });
      this.loadItems();
    },    
    onColumnFilter(params) {
      this.serverParams.name=params.columnFilters.name,
      this.serverParams.email=params.columnFilters.email,
      this.serverParams.entite_nom=params.columnFilters.entite_nom,
      this.serverParams.agence_nom=params.columnFilters.agence_nom,
      this.serverParams.agence_ville=params.columnFilters.agence_ville,
      this.serverParams.role_name=params.columnFilters.role_name,
      this.serverParams.grilletarifaires_libelle=params.columnFilters.grilletarifaires_libelle,
      this.serverParams.date_operation=params.columnFilters.date_operation,
      this.updateParams(params);
      this.loadItems();
    },
    // load items is what brings back the rows from server
    loadItems() {
      this.$store.dispatch('mandate/get_all_model',this.serverParams).then((response)=>{
          this.totalRecords = response.total;
          return this.rows =  store.getters['mandate/rowsModels'];
      })
    }
  },
  mounted(){
    // this.get_all_users()
    this.loadItems()
  }
  
}
</script>
